import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import BranchReportsListing from "../../components/BranchReportsListing";
import EventsReportsListing from "../../components/EventsReportsListing";
import MembersReportsListing from "../../components/MembersReportsListing";
import NonMembersReportsListing from "../../components/NonMembersReportsListing";
import RidesReportsListing from "../../components/RidesReportsListing";
import * as sessionActions from "../../redux/reports/actions";

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowData: null,
    };
  }

  handleFetchMemebersReports = (payload) => {
    this.props.actions.fetchMembersReports(payload);
  };

  handleExportToExcel = (payload, key) => {
    this.props.actions.exportToExcel(payload, key);
  };

  handleFetchNonMemebersReports = (payload) => {
    this.props.actions.fetchNonMembersReports(payload);
  };

  fetchBranchReports = (obj) => {
    this.props.actions.fetchBranchReports(obj);
  };

  exportToExcelBranchReports = (obj) => {
    this.props.actions.exportToExcelBranchReports(obj);
  };

  fetchEventsReports = (obj) => {
    this.props.actions.fetchEventsReports(obj);
  };

  exportToExcelEventsReports = (obj) => {
    this.props.actions.exportToExcelEventsReports(obj);
  };

  fetchRidesReports = (obj) => {
    this.props.actions.fetchRidesReports(obj);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchState(data);
  };

  exportToExcelRidesReports = (obj) => {
    this.props.actions.exportToExcelRidesReports(obj);
  };

  clearingPreviousReducer = (payload) => {
    this.props.actions.clearingPreviousReducer(payload);
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "members":
        return (
          <MembersReportsListing
            fetchingMembersReports={this.props.fetchingMembersReports}
            membersReportsList={this.props.membersReportsList}
            handleFetchMemebersReports={this.handleFetchMemebersReports}
            membersReportsListCount={this.props.membersReportsListCount}
            exportToExcelStatus={this.props.exportToExcelStatus}
            handleExportToExcel={this.handleExportToExcel}
            elements={this.props.elements}
            countries={this.props.country}
            clearingPreviousReducer={this.clearingPreviousReducer}
            accessibleCountries={this.props.accessibleCountries}
            userProfile={this.props.userProfile}
          />
        );

      case "non-members":
        return (
          <NonMembersReportsListing
            fetchingNonMembersReports={this.props.fetchingNonMembersReports}
            nonMembersReportsList={this.props.nonMembersReportsList}
            handleFetchNonMemebersReports={this.handleFetchNonMemebersReports}
            nonMembersReportsListCount={this.props.nonMembersReportsListCount}
            exportToExcelStatus={this.props.exportToExcelStatus}
            handleExportToExcel={this.handleExportToExcel}
            elements={this.props.elements}
            countries={this.props.country}
            clearingPreviousReducer={this.clearingPreviousReducer}
            accessibleCountries={this.props.accessibleCountries}
            userProfile={this.props.userProfile}
          />
        );

      case "branches":
        return (
          <BranchReportsListing
            fetchBranchReports={this.fetchBranchReports}
            clearingPreviousReducer={this.clearingPreviousReducer}
            exportToExcelBranchReports={this.exportToExcelBranchReports}
            handleFetchState={this.handleFetchState}
            fetchingBranchReports={this.props.fetchingBranchReports}
            branchReportsList={this.props.branchReportsList}
            branchReportsListCount={this.props.branchReportsListCount}
            exportToExcelBranchReportsStatus={
              this.props.exportToExcelBranchReportsStatus
            }
            elements={this.props.elements}
            countries={this.props.country}
            accessibleCountries={this.props.accessibleCountries}
          />
        );

      case "events":
        return (
          <EventsReportsListing
            fetchEventsReports={this.fetchEventsReports}
            clearingPreviousReducer={this.clearingPreviousReducer}
            exportToExcelEventsReports={this.exportToExcelEventsReports}
            handleFetchState={this.handleFetchState}
            fetchingEventsReports={this.props.fetchingEventsReports}
            eventsReportsList={this.props.eventsReportsList}
            eventsReportsListCount={this.props.eventsReportsListCount}
            exportToExcelEventReportsStatus={
              this.props.exportToExcelEventReportsStatus
            }
            elements={this.props.elements}
            countries={this.props.country}
            accessibleCountries={this.props.accessibleCountries}
          />
        );

      case "rides":
        return (
          <RidesReportsListing
            fetchRidesReports={this.fetchRidesReports}
            clearingPreviousReducer={this.clearingPreviousReducer}
            exportToExcelRidesReports={this.exportToExcelRidesReports}
            handleFetchState={this.handleFetchState}
            fetchingRidesReports={this.props.fetchingRidesReports}
            ridesReportsList={this.props.ridesReportsList}
            ridesReportsListCount={this.props.ridesReportsListCount}
            exportToExcelRideReportsStatus={
              this.props.exportToExcelRideReportsStatus
            }
            elements={this.props.elements}
            countries={this.props.country}
            accessibleCountries={this.props.accessibleCountries}
          />
        );

      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    fetchingMembersReports: state.Reports.fetchingMembersReports,
    membersReportsList: state.Reports.membersReportsList,
    membersReportsListCount: state.Reports.membersReportsListCount,
    exportToExcelStatus: state.Reports.exportToExcelStatus,
    fetchingNonMembersReports: state.Reports.fetchingNonMembersReports,
    nonMembersReportsList: state.Reports.nonMembersReportsList,
    nonMembersReportsListCount: state.Reports.nonMembersReportsListCount,
    fetchingBranchReports: state.Reports.fetchingBranchReports,
    branchReportsList: state.Reports.branchReportsList,
    branchReportsListCount: state.Reports.branchReportsListCount,
    exportToExcelBranchReportsStatus:
      state.Reports.exportToExcelBranchReportsStatus,
    fetchingEventsReports: state.Reports.fetchingEventsReports,
    eventsReportsList: state.Reports.eventsReportsList,
    eventsReportsListCount: state.Reports.eventsReportsListCount,
    exportToExcelEventReportsStatus:
      state.Reports.exportToExcelEventReportsStatus,
    fetchingRidesReports: state.Reports.fetchingRidesReports,
    ridesReportsList: state.Reports.ridesReportsList,
    ridesReportsListCount: state.Reports.ridesReportsListCount,
    exportToExcelRideReportsStatus:
      state.Reports.exportToExcelRideReportsStatus,
    elements: state.Elements.elements,
    country: state.Global.countries,
    accessibleCountries: state.Auth.userProfile.accessibleCountries,
    userProfile: state.Auth.currentUserProfile,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Reports)
);
